import { lazy, Suspense } from 'react';
import Loading from '../../../shared/placeholders/Loading/Loading';

const NewResourcePane = lazy(
  () => import('v4/pages/resources/pane/ResourcePane')
);

export default props => {
  return (
    <Suspense fallback={<Loading />}>
      <NewResourcePane {...props} />
    </Suspense>
  );
};
